<template>
  <DialogLayout
    title="詳細情報"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <RegistrationSymbolMasterForm
        ref="registrationSymbolForm"
        v-model="registrationSymbolFormModel"
        label-width="10em"
        formMode="edit"
        :autocomplete-owner-code-set="autocompleteOwnerCodeSet"
        :autocomplete-model-code-set="autocompleteModelCodeSet"
      />
    </template>
    <template #footer>
      <EditDialogFooter
        @update="clickUpdate"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import RegistrationSymbolMasterForm from '@/components/organisms/dialog/master/RegistrationSymbolMasterForm.vue'
import EditDialogFooter from '@/components/organisms/dialog/EditDialogFooter.vue'
import RegistrationSymbolAutocompleteLoader from '@/mixins/RegistrationSymbolAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    RegistrationSymbolMasterForm,
    EditDialogFooter
  },
  mixins: [
    RegistrationSymbolAutocompleteLoader
  ],
  props: {
    autocompleteOwnerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      registrationSymbolFormModel: {
        registration_symbol: undefined,
        owner_code: undefined,
        start_date: undefined,
        end_date: undefined,
        model_code: undefined,
        aircraft_type: undefined,
        weight_1: undefined,
        noise_level_1: undefined,
        weight_2: undefined,
        noise_level_2: undefined,
        weight_3: undefined,
        noise_level_3: undefined,
        remarks: undefined,
        aircraft_attribute: undefined,
        updated_on: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
  },
  methods: {
    async clickUpdate () {
      this.$loadingMask.on()

      this.$refs.registrationSymbolForm.validate()
        .then((valid) => {
          return this.$axios.put('/registration-symbol', this.registrationSymbolFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.margeOwnerCodeSet(this.registrationSymbolFormModel.owner_code)
          this.margeModelCodeSet(this.registrationSymbolFormModel.model_code)
          this.$emit('refresh')
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['registration_symbol', 'owner_code', 'model_code']
      this.$nextTick(() => {
        this.$refs.registrationSymbolForm.clearFields()
        Object.keys(this.registrationSymbolFormModel)
          .forEach((x) => {
            if (trimItem.includes(x)) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            this.$set(this.registrationSymbolFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
